import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type { RentalResponseDTO } from "@/shared/types/rental.types";
import type {
  CreateRentalDTO,
  UpdateRentalDTO,
  PickupDTO,
  ReturnDTO,
  RentalAdminSearchParams,
} from "../types";

export const rentalAdminService = {
  search: async (
    params?: RentalAdminSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<RentalResponseDTO>> => {
    const response = await api.get<PageResponseDTO<RentalResponseDTO>>(
      API_ENDPOINTS.RENTALS_ADMIN.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<RentalResponseDTO> => {
    const response = await api.get<RentalResponseDTO>(
      API_ENDPOINTS.RENTALS_ADMIN.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  create: async (data: CreateRentalDTO): Promise<RentalResponseDTO> => {
    const response = await api.post<RentalResponseDTO>(
      API_ENDPOINTS.RENTALS_ADMIN.BASE,
      data,
    );
    return response.data;
  },

  update: async (
    id: number,
    data: UpdateRentalDTO,
  ): Promise<RentalResponseDTO> => {
    const response = await api.put<RentalResponseDTO>(
      API_ENDPOINTS.RENTALS_ADMIN.BY_ID(id),
      data,
    );
    return response.data;
  },

  cancel: async (id: number): Promise<void> => {
    await api.post(API_ENDPOINTS.RENTALS_ADMIN.CANCEL(id));
  },

  pickup: async (id: number, data: PickupDTO): Promise<RentalResponseDTO> => {
    const response = await api.post<RentalResponseDTO>(
      API_ENDPOINTS.RENTALS_ADMIN.PICKUP(id),
      data,
    );
    return response.data;
  },

  return: async (id: number, data: ReturnDTO): Promise<RentalResponseDTO> => {
    const response = await api.post<RentalResponseDTO>(
      API_ENDPOINTS.RENTALS_ADMIN.RETURN(id),
      data,
    );
    return response.data;
  },
};
